<div class="flex flex-col md:flex-row gap-3">
  <div class="flex flex-col sm:flex-row gap-3">
    <div class="flex-1">
      <ui-switch-bar
        [formField]="form.data.utilityType"
        class="w-full sm:w-[153px] inline-block flex-none"
        (valueChange)="onChangeFilter()"
        data-track="consumption-utility-type-switch-bar"
      >
        <ui-switch-bar-option value="ELECTRICITY">
          <ng-icon name="heroBolt" size="20" class="!block" />
          {{ 'cockpit.analysis.consumption.filters.utilityTypeElectricity' | transloco }}
        </ui-switch-bar-option>
        <ui-switch-bar-option value="GAS">
          <ng-icon name="heroFire" size="20" class="!block" />
          {{ 'cockpit.analysis.consumption.filters.utilityTypeGas' | transloco }}
        </ui-switch-bar-option>
      </ui-switch-bar>
    </div>

    <div class="md:hidden flex-none">
      <ng-container [ngTemplateOutlet]="viewSwitchBar" />
    </div>
  </div>

  <div class="flex-1 flex gap-3">
    <div
      class="flex-1 grid grid-cols-1 gap-3"
      [ngClass]="showLocationsSelect() ? 'sm:grid-cols-3' : 'sm:grid-cols-2'"
    >
      <ng-container [ngTemplateOutlet]="directionsSelect" />
      @if (showLocationsSelect()) {
        <div class="hidden sm:block">
          <ng-container [ngTemplateOutlet]="locationsSelect" />
        </div>
      }
      <div class="hidden sm:block">
        <ng-container [ngTemplateOutlet]="energyInterfacesSelect" />
      </div>
    </div>
    <ui-button
      class="sm:hidden"
      mode="outlined"
      [iconOnly]="true"
      [ariaLabel]="'cockpit.analysis.consumption.filters.moreFiltersOpenButton' | transloco"
      (click)="mobile.showModal()"
    >
      <ng-icon name="heroFunnel" size="20" class="!block" />
    </ui-button>
  </div>

  <div class="flex-none hidden md:block">
    <ng-container [ngTemplateOutlet]="viewSwitchBar" />
  </div>
</div>

<ui-simple-dialog #mobile>
  <ui-simple-dialog-layout (clickCancel)="mobile.close()" class="block w-full">
    <ng-container slot="title">
      {{ 'cockpit.analysis.consumption.filters.moreFiltersTitle' | transloco }}
    </ng-container>
    <div class="flex flex-col gap-6">
      <ng-container [ngTemplateOutlet]="directionsSelect" />
      @if (showLocationsSelect()) {
        <ng-container [ngTemplateOutlet]="locationsSelect" />
      }
      <ng-container [ngTemplateOutlet]="energyInterfacesSelect" />
    </div>
  </ui-simple-dialog-layout>
</ui-simple-dialog>

<ng-template #viewSwitchBar>
  <ui-switch-bar
    [formField]="form.view"
    class="w-full sm:w-[116px] inline-block"
    (valueChange)="onChangeFilter()"
    data-track="consumption-view-switch-bar"
  >
    <ui-switch-bar-option value="line">
      <ng-icon name="heroArrowTrendingUp" size="20" class="!block" />
    </ui-switch-bar-option>
    <ui-switch-bar-option value="bar">
      <ng-icon name="heroChartBar" size="20" class="!block" />
    </ui-switch-bar-option>
    <ui-switch-bar-option value="table">
      <ng-icon name="heroListBullet" size="20" class="!block" />
    </ui-switch-bar-option>
  </ui-switch-bar>
</ng-template>

<ng-template #directionsSelect>
  <ui-select
    [ariaLabel]="'cockpit.analysis.consumption.filters.directionLabel' | transloco"
    [formField]="form.data.direction"
    (selectChange)="onChangeFilter()"
    data-track="consumption-direction-select"
  >
    <option value="CONSUMPTION" [selected]="form.data.direction().value() === 'CONSUMPTION'">
      {{ 'cockpit.analysis.consumption.filters.directionConsumption' | transloco }}
    </option>
    <option value="PRODUCTION" [selected]="form.data.direction().value() === 'PRODUCTION'">
      {{ 'cockpit.analysis.consumption.filters.directionProduction' | transloco }}
    </option>
  </ui-select>
</ng-template>

<ng-template #locationsSelect>
  @if (locationsLoading()) {
    <ui-skeleton class="block h-10 w-full rounded-md" />
  } @else {
    <ui-select
      [attr.aria-label]="'cockpit.analysis.consumption.filters.locationsLabel' | transloco"
      [formField]="form.data.locationID"
      (selectChange)="onChangeFilter()"
    >
      <option value="" [selected]="form.data.locationID().value() === ''">
        {{ 'cockpit.analysis.consumption.filters.locationsAll' | transloco }}
      </option>
      @for (location of locations(); track location.id) {
        <option [value]="location.id" [selected]="form.data.locationID().value() === location.id">
          {{ location | formatLocationName }}
        </option>
      }
    </ui-select>
  }
</ng-template>

<ng-template #energyInterfacesSelect>
  @if (energyInterfacesLoading()) {
    <ui-skeleton class="block h-10 w-full rounded-md" />
  } @else {
    <ui-select
      [attr.aria-label]="'cockpit.analysis.consumption.filters.interfacesLabel' | transloco"
      [formField]="form.data.energyInterfaceID"
      (selectChange)="onChangeFilter()"
    >
      <option value="" [selected]="form.data.energyInterfaceID().value() === ''">
        {{ 'cockpit.analysis.consumption.filters.interfacesAll' | transloco }}
      </option>
      @for (energyInterface of energyInterfaces(); track energyInterface.id) {
        <option
          [value]="energyInterface.id"
          [selected]="form.data.energyInterfaceID().value() === energyInterface.id"
        >
          {{ energyInterface.label || '-' }}
        </option>
      }
    </ui-select>
  }
</ng-template>
